module.exports = __webpack_public_path__ + "static/blogAuthor-abfd9aa9f6a9b9ee07d5c76e2d7185fd.svg";